import React, { Component } from "react";
import TextInput from "../../inputs/TextInput";
import { translate } from "../../../utils/useful";


class NewColumn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnToggle: true,
        };
        // this.inputRef = React.createRef();
    }

    addColumn = () => {
        const { addNewColumn } = this.props;
        if (this.state.text !== "") {
            addNewColumn(this.state.text);
            this.setState({ columnToggle: !this.state.columnToggle }, () => {
                this.setState({ text: null })
            });
        } else {
            alert("Add a TaskName !!!!!!");
        }
    }

    render() {
        const { columnToggle } = this.state;

        return (
            <div className={columnToggle ? "new-column newC mx-2" : "new-columnInput newC mx-2"}>
                {columnToggle ? (
                    <button className="flexcc" onClick={() => this.setState({ columnToggle: !this.state.columnToggle })}>
                        <img width={22} src="/assets/icons/plus-black.svg" />
                        <p>Add Section</p>
                    </button>
                ) : (
                    <div className="new-columnSave mx-3 modern-input">
                        <TextInput data={this.state.text} header={{ key: 'textTitle', information: { placeholder: 'STATUS NAME', } }} changeValue={(key, value, extra) => { this.setState({ text: value }) }} />

                        {/* <TextInput ref={this.inputRef} type="text" className="status-input" placeholder="STATUS NAME" /> */}
                            <button className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }} onClick={() => this.addColumn()}>
                                <p>{translate('save')}</p>
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default NewColumn;

// import React, { useRef, useState } from "react";

// const NewColumn = ({ addNewColumn }) => {
//     const [columnToggle, setColumnToggle] = useState(true);
//     const inputRef = useRef();
//     function addColumn(inputValue) {
//         if(inputValue!=""){
//         addNewColumn(inputValue);
//         setColumnToggle((prev) => !prev);}
//         else{
//             alert("Add a TaskName !!!!!!!!!!")
//         }
//     }
//     return (
//         <div className={columnToggle? "new-column " + " newC " : "new-columnInput " + " newC "}>
//             {columnToggle ? (
//                 <button className="flexcc " onClick={() => setColumnToggle((prev) => !prev)}>
//                     <img width={22} src="/assets/icons/plus-black.svg"/>
//                     <p>Add Section</p>
//                 </button>
//             ) : (
//                 <div className="new-columnSave mx-3">
//                     <input ref={inputRef} type="text" className="status-input" placeholder="STATUS NAME" />
//                     <button className="save-btn" onClick={() => addColumn(inputRef.current.value)}>
//                         <p>save</p>
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default NewColumn;
